import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';

const CarForHeroesPressRelease = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        backgroundColor: '#fff',
        minHeight: '100vh',
        maxWidth: 900,
        mx: 'auto',
      }}
    >
      <Typography variant="h3" gutterBottom>
        Miami Lakes Cars for Heroes – 10/11/25
      </Typography>

      <Typography paragraph>
        On Saturday, October 11, the Town of Miami Lakes Public Safety Committee hosted Cars for
        Heroes, a community car show dedicated to local first responders. The event featured a
        variety of vendors. Among them, the Vision Zero Team attended the event to continue to
        spread awareness, answer questions and collect public input through surveys.
      </Typography>

      {/* Photo 1 */}
      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-car-for-heroes-press-release-event1.jpg`}
          alt="Vision Zero team member explaining the initiative to a concerned Miami Laker"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" align="center" sx={{ mt: 1 }}>
          Vision Zero team member explaining the initiative to a concerned Miami Laker.
        </Typography>
      </Box>

      <Typography paragraph>
        Throughout the event, Miami Lakers received information about the Vision Zero initiative and
        general transportation safety. The team distributed free lighted wristbands, reflective
        wristbands, and bicycle helmets, as well as helmet fittings, all aimed at promoting safety
        and sparking conversations about mobility concerns in Miami Lakes.
      </Typography>

      {/* Photo 2 */}
      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-car-for-heroes-press-release-event2.jpg`}
          alt="Vision Zero team member showing the town crash map to a Miami Laker"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" align="center" sx={{ mt: 1 }}>
          Vision Zero team member showing the town crash map to a Miami Laker.
        </Typography>
      </Box>

      <Typography paragraph>
        The Vision Zero Team collected public input surveys both virtually and on paper, assisted
        residents in navigating the Vision Zero website, and encouraged participation in the public
        comment map. Additionally, the team had a large posterboard map where Miami Lakers could
        mark where they live and identify areas where they feel unsafe traveling within the Town.
      </Typography>

      {/* Photo 3 */}
      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-car-for-heroes-press-release-event3.jpg`}
          alt="Vision Zero team member assisting a Miami Laker with a public input map of the town"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" align="center" sx={{ mt: 1 }}>
          Vision Zero team member assisting a Miami Laker with a public input map of the town.
        </Typography>
      </Box>

      <Typography paragraph>
        The event had an excellent turnout and the Vision Zero tent engaged with concerned Miami
        Lakers and continued to add to the public voice in the effort. The event contributed to a
        growing total of approximately 150 survey responses collected through multiple outreach
        efforts. In addition, 8 helmets were distributed and fitted, and 25 wristbands were given
        away at the event.
      </Typography>

      {/* Photo 4 */}
      <Box sx={{ my: 3 }}>
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/images/news-car-for-heroes-press-release-event4.jpg`}
          alt="One of the car show participants providing input on the town crash map"
          sx={{ width: '100%', borderRadius: 2 }}
        />
        <Typography variant="caption" display="block" align="center" sx={{ mt: 1 }}>
          One of the car show participants providing input on the town crash map.
        </Typography>
      </Box>

      <Typography paragraph>
        We invite you to continue participating as this public engagement effort just started. Join
        the conversation through our social media channels.
      </Typography>

      {/* Social Media Links */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <InstagramIcon color="action" />
          <Link
            href="https://www.instagram.com/miamilakesvisionzero"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            @miamilakesvisionzero
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <XIcon color="action" />
          <Link
            href="https://twitter.com/miamilakesvz"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            @miamilakesvz
          </Link>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FacebookIcon color="action" />
          <Link
            href="https://www.facebook.com/share/1HS7Sy2A9Z/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="inherit"
            sx={{ fontWeight: 500 }}
          >
            Vision Zero Miami Lakes
          </Link>
        </Box>
      </Box>

      <Typography paragraph>
        Be part of the conversation and participate by completing the community survey using{' '}
        <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
          this survey link
        </Link>
        .
      </Typography>

      <Typography paragraph>
        Our website and social media channel continue posting project updates and upcoming events.
      </Typography>

      <Typography paragraph>
        Para español:{' '}
        <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
          haga clic aquí
        </Link>{' '}
        (seleccione español)
      </Typography>
    </Box>
  );
};

export default CarForHeroesPressRelease;
